import connectContainer from './LogoutButtonContainer';
import LogoutButton from './LogoutButton';

export default connectContainer(LogoutButton);
